<template>
  <div class="ad-item" @click="goPage">
    <img :src="data.mainPicture | imageToHttps | imageToWebp($webpSurpport)" alt="">
  </div>
</template>

<script>
export default {
  name: 'adItem',
  props: ['data'],
  methods: {
    goPage() {
      this.$emit('handleClick')
      // location.href = this.data.pageUrl
    }
  }
}
</script>

<style lang="scss" scoped>
.ad-item{
  height: 4.6rem;
}
.ad-item img{
  width: 100%;
  height: 100%;
}
</style>
